/**
 * Formats an offer expiration date string for display.
 * Handles HTML-encoded strings from the BFF (e.g. "04&#x2F;29&#x2F;2026").
 */
export function formatExpiresOn(raw: string, locale: string): string {
  const decoded = raw.replace(/&#x2F;/g, "/").replace(/&amp;/g, "&");
  const date = new Date(decoded);
  if (Number.isNaN(date.getTime())) return "";
  return date.toLocaleDateString(locale, {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
}
